const TrainingsTab = ({ trainings, getStatusBadge, handleConfirmAttendance, darkMode }) => {
  return (
    <div>
      <h3 className={`text-xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-slate-800'}`}>Minhas Formações</h3>
      
      {trainings.length === 0 ? (
        <p className={`text-center py-8 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Sem formações atribuídas</p>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {trainings.map((training, idx) => (
            <div key={idx} className={`p-4 rounded-lg ${darkMode ? 'bg-slate-700/50' : 'bg-slate-100'}`}>
              <div className="flex items-center justify-between mb-2">
                <span className={`font-medium ${darkMode ? 'text-white' : 'text-slate-800'}`}>{training.title}</span>
                {getStatusBadge(training.status)}
              </div>
              <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>{training.provider}</p>
              <p className={`text-sm mt-1 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>{training.start_date} | {training.duration_hours}h</p>
              {training.certification && (
                <span className="inline-flex items-center gap-1 mt-2 text-xs text-emerald-400">
                  <span>🏆</span> Com certificação
                </span>
              )}
              
              {/* Confirm Attendance Button for ACT compliance */}
              {training.status !== 'completed' && !training.attendance_confirmed && (
                <button
                  onClick={() => handleConfirmAttendance(training.training_id)}
                  className="mt-3 w-full px-3 py-2 rounded-lg bg-emerald-600 text-white text-sm hover:bg-emerald-500 transition-colors"
                  data-testid={`confirm-attendance-${training.training_id}`}
                >
                  ✅ Confirmar Presença (ACT)
                </button>
              )}
              {training.attendance_confirmed && (
                <div className={`mt-3 p-2 rounded-lg text-center ${darkMode ? 'bg-emerald-900/30' : 'bg-emerald-100'}`}>
                  <span className="text-xs text-emerald-400">✅ Presença confirmada</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TrainingsTab;
